import { useEffect, useState } from 'react';
import { FirebaseConfig } from '@erecruit/modules';

export interface AppConfig {
  REACT_APP_API_URL: string;
  REACT_APP_BASE_URL: string;
  REACT_APP_AUTHORITY: string;
  REACT_APP_ERECRUIT_URL: string;
  REACT_APP_GOOGLE_MAPS_KEY: string;
  REACT_APP_DISABLE_QUICK_SEARCH: boolean;
  REACT_APP_FIREBASE_CONFIG: FirebaseConfig;
}

let appConfig: AppConfig | undefined = undefined;

const initializeAppConfig = async (): Promise<void> => {
  const resp = await fetch(`/app-config.json`);
  const data: AppConfig = await resp.json();

  appConfig = {
    REACT_APP_API_URL: data.REACT_APP_API_URL,
    REACT_APP_BASE_URL: data.REACT_APP_BASE_URL,
    REACT_APP_AUTHORITY: data.REACT_APP_AUTHORITY,
    REACT_APP_ERECRUIT_URL: data.REACT_APP_ERECRUIT_URL,
    REACT_APP_GOOGLE_MAPS_KEY: data.REACT_APP_GOOGLE_MAPS_KEY,
    REACT_APP_DISABLE_QUICK_SEARCH: data.REACT_APP_DISABLE_QUICK_SEARCH,
    REACT_APP_FIREBASE_CONFIG: data.REACT_APP_FIREBASE_CONFIG,
  };
};

export const useAppConfig = () => {
  const [config, setConfig] = useState(appConfig);

  useEffect(() => {
    if (!config) {
      initializeAppConfig()
        .then(() => setConfig(appConfig))
        .catch(() =>
          setConfig(() => {
            throw new Error('Error initializing app config');
          }),
        );
    }
  });

  return config;
};
